import { useAuth } from './useAuth'
import { useStores } from './useStores'

export const useValidateAuth = () => {
  const { store } = useStores()
  const { isLogin } = useAuth()

  const validateIsLogin = () => {
    if (!isLogin) {
      store.modal?.setLoginVisible(true)
      return false
    }

    return true
  }

  return {
    validateIsLogin,
  }
}
